import { configureStore, createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import mainReducer from "./features/main/mainSlice";
import authReducer from "./features/auth/authSlice";
import jishoWordsReducer, {
  createJishoWord, editJishoWord, deleteJishoWord,
} from "./features/jishoWords/jishoWordsSlice";
import paragraphsReducer, {
  createParagraph, editParagraph, deleteParagraph,
} from "./features/paragraphs/paragraphsSlice";
import adminsReducer, {
  createAdmin, editAdmin, deleteAdmin,
} from "./features/admins/adminsSlice";
import permissionsReducer, {
  createPermission, editPermission, deletePermission,
} from "./features/permissions/permissionsSlice";
import { adminApi } from "./adminApi";

const cacheInvalidation = createListenerMiddleware();

const mutationGroups = [
  { actions: [createAdmin, editAdmin, deleteAdmin], tag: "Admins" },
  { actions: [createPermission, editPermission, deletePermission], tag: "Permissions" },
  { actions: [createJishoWord, editJishoWord, deleteJishoWord], tag: "JishoWords" },
  { actions: [createParagraph, editParagraph, deleteParagraph], tag: "Paragraphs" },
];

// Invalidate only after a successful write. All mounted list queries
// revalidate automatically, including role options after permission updates.
mutationGroups.forEach(({ actions, tag }) => {
  cacheInvalidation.startListening({
    matcher: isAnyOf(...actions.map((action) => action.fulfilled)),
    effect: (_, api) => {
      api.dispatch(adminApi.util.invalidateTags([tag]));
    },
  });
});

export const store = configureStore({
  reducer: {
    main: mainReducer,
    auth: authReducer,
    admins: adminsReducer,
    permissions: permissionsReducer,
    jishoWords: jishoWordsReducer,
    paragraphs: paragraphsReducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .prepend(cacheInvalidation.middleware)
      .concat(adminApi.middleware),
});
